@if (isExpanded) {
    <div
        class="sidebar__backdrop"
        role="button"
        tabindex="0"
        aria-label="Close sidebar"
        (click)="onSidebarBackdropClick($event)"
        (keydown.enter)="onSidebarBackdropClick($event)"
        (keydown.space)="onSidebarBackdropClick($event); $event.preventDefault()"
    ></div>
}
<div class="sidebar" [class.sidebar--expanded]="isExpanded">
    <nav class="flex flex-col">
        <div class="menu__section">
            <a
                class="sidebar__link sidebar__link--top-level"
                routerLink="/"
                queryParamsHandling="merge"
                (click)="menuItemClicked()"
            >
                <span class="menu__iconCustomColor"><app-svg-icon name="home" size="lg" /></span>
                <span class="menu__listItem">Home</span>
            </a>

            @if (permissionService.getPermissionByName(PERMISSIONS.ENABLE_SALES_ASSIST)) {
                <a
                    class="sidebar__link sidebar__link--top-level"
                    [routerLink]="['/', SALES_ASSIST_ROUTE_PATHS.BASE]"
                    (click)="menuItemClicked()"
                >
                    <span class="menu__iconCustomColor"
                        ><app-svg-icon name="rocket" size="lg"
                    /></span>
                    <span class="menu__listItem">Sales Assist</span>
                </a>
            }

            @if (showCslDualApprovalNav) {
                <button class="menu__groupTitle" type="button" (click)="toggleApprovalsNav()">
                    <span class="menu__title">Approvals</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isApprovalsNavExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
                @if (isApprovalsNavExpanded) {
                    <div class="menu__groupContent">
                        <a
                            class="sidebar__link"
                            routerLink="/crm/csl-approvals/client"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="clients" size="lg"
                            /></span>
                            <span class="menu__listItem">Customer</span>
                        </a>
                        <a
                            class="sidebar__link"
                            routerLink="/crm/csl-approvals/order"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="orders" size="lg"
                            /></span>
                            <span class="menu__listItem">Order</span>
                        </a>
                    </div>
                }
            }

            @if (hasMyWorkLinks) {
                <button class="menu__groupTitle" type="button" (click)="toggleMyWork()">
                    <span class="menu__title">My Work</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isMyWorkExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
                @if (isMyWorkExpanded) {
                    <div class="menu__groupContent">
                        @if (permissionService.getPermissionByName(PERMISSIONS.APPROVE_PROPOSAL)) {
                            <a class="sidebar__link" href="#" (click)="onApprovalsNavClick($event)">
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="approval" size="lg"
                                /></span>
                                <span class="menu__listItem">Approvals</span>
                            </a>
                        }
                        @if (
                            permissionService.getPermissionByName(PERMISSIONS.VIEW_RETENTION_CHECKS)
                        ) {
                            <a
                                class="sidebar__link"
                                [routerLink]="[
                                    CRM_ROUTE_PATHS.BASE,
                                    CRM_ROUTE_PATHS.RETENTION_APPROVAL,
                                ]"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="schedule" size="lg"
                                /></span>
                                <span class="menu__listItem">Retention Checks</span>
                            </a>
                        }
                    </div>
                }
            }

            @if (hasPipelineLinks) {
                <button class="menu__groupTitle" type="button" (click)="togglePipeline()">
                    <span class="menu__title">Pipeline</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isPipelineExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
            }
            @if (hasPipelineLinks && isPipelineExpanded) {
                <div class="menu__groupContent">
                    @if (
                        permissionService.getPermissionByName(PERMISSIONS.VIEW_MY_LEAD) ||
                        permissionService.getPermissionByName(PERMISSIONS.VIEW_TEAM_LEADS)
                    ) {
                        <a
                            class="sidebar__link"
                            routerLink="/crm/lead-dashboard"
                            [queryParams]="pipelineMyLeadsQuery"
                            queryParamsHandling="merge"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="kanban" size="lg"
                            /></span>
                            <span class="menu__listItem">My Leads</span>
                        </a>
                    }
                    @if (
                        permissionService.getPermissionByName(PERMISSIONS.VIEW_TEAM_LEADS) &&
                        hasReportees()
                    ) {
                        <a
                            class="sidebar__link"
                            routerLink="/crm/lead-dashboard"
                            [queryParams]="pipelineTeamQuery"
                            queryParamsHandling="merge"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="square-kanban" size="lg"
                            /></span>
                            <span class="menu__listItem">Team pipeline</span>
                        </a>
                        <a
                            class="sidebar__link"
                            routerLink="/crm/lead-dashboard"
                            [queryParams]="pipelineUnassignedQuery"
                            queryParamsHandling="merge"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="inbox" size="lg"
                            /></span>
                            <span class="menu__listItem">Unassigned Customers</span>
                        </a>
                    }
                </div>
            }

            @if (!showCslDualApprovalNav) {
                <button class="menu__groupTitle" type="button" (click)="toggleCustomer()">
                    <span class="menu__title">Customer</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isCustomerExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
            }
            @if (!showCslDualApprovalNav && isCustomerExpanded) {
                <div class="menu__groupContent">
                    @if (permissionService.getPermissionByName(PERMISSIONS.VIEW_CLIENT)) {
                        <a
                            class="sidebar__link"
                            routerLink="/crm/dashboard"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="clients" size="lg"
                            /></span>
                            <span class="menu__listItem">Customer Directory</span>
                        </a>
                    }
                    @if (shikshaPermissionsService.isShikshaFeature(SHIKSHA_FEATURES.VIEW)) {
                        <a
                            class="sidebar__link"
                            routerLink="/crm/view-client-shiksha"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="folder_open" size="lg"
                            /></span>
                            <span class="menu__listItem">Shiksha Customer Directory</span>
                        </a>
                    }
                    @if (shikshaPermissionsService.isShikshaFeature(SHIKSHA_FEATURES.CREATE)) {
                        <a
                            class="sidebar__link"
                            [routerLink]="['/crm', CRM_ROUTE_PATHS.CREATE]"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="user_plus" size="lg"
                            /></span>
                            <span class="menu__listItem">Create New Customer</span>
                        </a>
                    }
                </div>
            }

            @if (showFinanceNav) {
                <button class="menu__groupTitle" type="button" (click)="toggleFinanceNav()">
                    <span class="menu__title">Payments</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isFinanceNavExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
                @if (isFinanceNavExpanded) {
                    <div class="menu__groupContent">
                        <a
                            class="sidebar__link"
                            routerLink="/finance/payments"
                            (click)="menuItemClicked()"
                            data-testid="sidebar-finance-payments"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="payments" size="lg"
                            /></span>
                            <span class="menu__listItem">Payment claims</span>
                        </a>
                    </div>
                }
            }

            @if (hasPerformanceLinks) {
                <button class="menu__groupTitle" type="button" (click)="togglePerformance()">
                    <span class="menu__title">Performance</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isPerformanceExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
            }
            @if (hasPerformanceLinks && isPerformanceExpanded) {
                <div class="menu__groupContent">
                    @if (
                        permissionService.getPermissionByName(PERMISSIONS.VIEW_MY_RUC_DASHBOARD) ||
                        permissionService.getPermissionByName(PERMISSIONS.VIEW_TEAM_RUC_DASHBOARD)
                    ) {
                        <a class="sidebar__link" routerLink="/crm/ruc" (click)="menuItemClicked()">
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="insights" size="lg"
                            /></span>
                            <span class="menu__listItem">Retention (RUC)</span>
                        </a>
                    }
                    @if (
                        permissionService.getPermissionByName(
                            PERMISSIONS.VIEW_MY_REVENUE_DASHBOARD
                        ) ||
                        permissionService.getPermissionByName(
                            PERMISSIONS.VIEW_TEAM_REVENUE_DASHBOARD
                        )
                    ) {
                        <a
                            class="sidebar__link"
                            [routerLink]="revenueDashboardPath()"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="assessment" size="lg"
                            /></span>
                            <span class="menu__listItem">Revenue</span>
                        </a>
                    }
                </div>
            }

            <!-- Independent links (no group): keep at the end -->
            @if (hasAcademicCalendarAccess) {
                <a
                    class="sidebar__link"
                    routerLink="/academic-calendar"
                    (click)="menuItemClicked()"
                >
                    <span class="menu__iconCustomColor"
                        ><app-svg-icon name="event" size="lg"
                    /></span>
                    <span class="menu__listItem">Academic Calendar</span>
                </a>
            }

            @if (hasFieldVisitAccess) {
                <a class="sidebar__link" routerLink="/field-visit" (click)="menuItemClicked()">
                    <span class="menu__iconCustomColor"
                        ><app-svg-icon name="location-on" size="lg"
                    /></span>
                    <span class="menu__listItem">Field Visit</span>
                </a>
            }

            @if (permissionService.getPermissionByName(PERMISSIONS.VIEW_ORDER)) {
                <a
                    class="sidebar__link"
                    routerLink="/school-site/orders"
                    (click)="menuItemClicked()"
                >
                    <span class="menu__iconCustomColor"
                        ><app-svg-icon name="orders" size="lg"
                    /></span>
                    <span class="menu__listItem">Orders Dashboard</span>
                </a>
            }
            @if (hasMcpAnalyticsLinks) {
                <button class="menu__groupTitle" type="button" (click)="toggleMcpAnalytics()">
                    <span class="menu__title">Analytics</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isMcpAnalyticsExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
            }
            @if (hasMcpAnalyticsLinks && isMcpAnalyticsExpanded) {
                <div class="menu__groupContent">
                    <a
                        class="sidebar__link"
                        routerLink="/mcp-analytics"
                        (click)="menuItemClicked()"
                    >
                        <span class="menu__iconCustomColor"
                            ><app-svg-icon name="grid_view" size="lg"
                        /></span>
                        <span class="menu__listItem">MCP Analytics</span>
                    </a>
                </div>
            }

            @if (permissionService.getPermissionByName(PERMISSIONS.VIEW_SIS_PORTFOLIO)) {
                <a class="sidebar__link" routerLink="/sis/portfolio" (click)="menuItemClicked()">
                    <span class="menu__iconCustomColor"
                        ><app-svg-icon name="kanban" size="lg"
                    /></span>
                    <span class="menu__listItem">Customer Onboarding</span>
                </a>
            }

            <!-- Settings: disabled; replace @if (false) with @if (true) or a component flag to restore. -->
            @if (false) {
                <button class="menu__groupTitle" type="button" (click)="toggleSettings()">
                    <span class="menu__title">Settings</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isSettingsExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
                @if (isSettingsExpanded) {
                    <div class="menu__groupContent">
                        <a class="sidebar__link" routerLink="/help" (click)="menuItemClicked()">
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="help_outline" size="lg"
                            /></span>
                            <span class="menu__listItem">Help & Support</span>
                        </a>
                        @if (permissionService.getPermissionByName(PERMISSIONS.VIEW_SERVICE_DESK)) {
                            <a
                                class="sidebar__link"
                                routerLink="/service-desk"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="settings" size="lg"
                                /></span>
                                <span class="menu__listItem">Admin Settings</span>
                            </a>
                        }
                        @if (
                            permissionService.getPermissionByName(
                                PERMISSIONS.VIEW_TRANSLATION_MANAGEMENT
                            )
                        ) {
                            <a
                                class="sidebar__link"
                                routerLink="/translation-management"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="translate" size="lg"
                                /></span>
                                <span class="menu__listItem">LexiHub</span>
                            </a>
                        }
                    </div>
                }
            }

            @if (showManageWebsite) {
                <button class="menu__groupTitle" type="button" (click)="toggleManageWebsite()">
                    <span class="menu__title">Manage website</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isManageWebsiteExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
                @if (isManageWebsiteExpanded) {
                    <div class="menu__groupContent">
                        @if (permissionService.getPermissionByName(PERMISSIONS.MANAGE_BLOGS)) {
                            <a
                                class="sidebar__link"
                                routerLink="/blogs"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="file-text" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage blogs</span>
                            </a>
                        }
                        @if (
                            permissionService.getPermissionByName(
                                PERMISSIONS.MANAGE_TEACHER_RESOURCES
                            )
                        ) {
                            <a
                                class="sidebar__link"
                                routerLink="/teacher-resources"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="graduation-cap" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage teacher resources</span>
                            </a>
                        }
                        @if (
                            permissionService.getPermissionByName(PERMISSIONS.MANAGE_CBE_RESOURCES)
                        ) {
                            <a
                                class="sidebar__link"
                                routerLink="/cbe-resources"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="category" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage CBE resources</span>
                            </a>
                        }
                        @if (permissionService.getPermissionByName(PERMISSIONS.MANAGE_TEAMS)) {
                            <a
                                class="sidebar__link"
                                routerLink="/teams"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="people" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage teams</span>
                            </a>
                        }
                        @if (permissionService.getPermissionByName(PERMISSIONS.MANAGE_CAREERS)) {
                            <a
                                class="sidebar__link"
                                routerLink="/careers"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="work" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage careers</span>
                            </a>
                        }
                        @if (permissionService.getPermissionByName(PERMISSIONS.MANAGE_WEBINARS)) {
                            <a
                                class="sidebar__link"
                                routerLink="/webinars"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="insights" size="lg"
                                /></span>
                                <span class="menu__listItem">Ei Webinars</span>
                            </a>
                        }
                        @if (permissionService.getPermissionByName(PERMISSIONS.MANAGE_NEWS)) {
                            <a
                                class="sidebar__link"
                                routerLink="/in-the-news"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="message-square" size="lg"
                                /></span>
                                <span class="menu__listItem">In the News</span>
                            </a>
                        }
                        @if (permissionService.getPermissionByName(PERMISSIONS.MANAGE_DOWNLOADS)) {
                            <a
                                class="sidebar__link"
                                routerLink="/downloads"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="download" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage downloads</span>
                            </a>
                        }
                        @if (
                            permissionService.getPermissionByName(PERMISSIONS.MANAGE_NEWSLETTERS)
                        ) {
                            <a
                                class="sidebar__link"
                                routerLink="/newsletters"
                                (click)="menuItemClicked()"
                            >
                                <span class="menu__iconCustomColor"
                                    ><app-svg-icon name="download" size="lg"
                                /></span>
                                <span class="menu__listItem">Manage newsletter</span>
                            </a>
                        }
                    </div>
                }
            }

            @if (canShowEiBanner) {
                <button class="menu__groupTitle" type="button" (click)="togglePreferences()">
                    <span class="menu__title">Preferences</span>
                    <span class="menu__expandIcon">
                        <span class="menu__expandIconIcon">
                            <app-svg-icon
                                [name]="
                                    isPreferencesExpanded
                                        ? PRODUCT_BLOCK.COLLAPSE_ICON
                                        : PRODUCT_BLOCK.EXPAND_ICON
                                "
                                size="lg"
                            />
                        </span>
                    </span>
                </button>
                @if (isPreferencesExpanded) {
                    <div class="menu__groupContent">
                        <a
                            class="sidebar__link"
                            routerLink="/ei-banner"
                            (click)="menuItemClicked()"
                        >
                            <span class="menu__iconCustomColor"
                                ><app-svg-icon name="settings" size="lg"
                            /></span>
                            <span class="menu__listItem">Ei-banner</span>
                        </a>
                    </div>
                }
            }
        </div>
    </nav>
</div>
